<template>
  <b-overlay :show="show" opacity="0.4" blur="2px" variant="dark" no-wrap>
    <template #overlay>
      <div class="panel-loading">
        <img src="images/ico-loading.gif">
        <div>{{$t(message || "Loading...")}}</div>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: "PanelLoading",
  props: ["show", "message"]
}
</script>

<style scoped>

</style>